import React, { useRef, useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
import './Testimonials.css';

// Import images (Keep your existing imports)
import user_1 from '../assets/videos/student 6.jpg';
import user_2 from '../assets/videos/student.jpg';
import user_3 from '../assets/videos/student2.jpg';
import user_4 from '../assets/videos/student3.jpg';
import user_5 from '../assets/videos/student4.jpg';
import user_6 from '../assets/videos/student5.jpg';
import user_7 from '../assets/videos/student 6.jpg';
import user_8 from '../assets/videos/student.jpg';
import user_9 from '../assets/videos/student2.jpg';
import user_10 from '../assets/videos/student3.jpg';
import user_11 from '../assets/videos/student4.jpg';
import user_12 from '../assets/videos/student5.jpg';
import user_13 from '../assets/videos/student 6.jpg';
import user_14 from '../assets/videos/student3.jpg';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const sliderRef = useRef(null);

  const reviews = [
    { name: 'Divya', location: 'MH Academy, India', img: user_1, text: 'MH Academy provides top-notch education with experienced faculty. The environment is truly inspiring! Highly recommended.' },
    { name: 'Thrisha', location: 'MH Academy, India', img: user_2, text: 'The courses at MH Academy are well-structured and the faculty is extremely supportive. My learning experience has been amazing!' },
    { name: 'Honnu Ambika', location: 'MH Academy, India', img: user_3, text: 'MH Academy transformed my career! The hands-on approach to learning made all the difference.' },
    { name: 'Ambika', location: 'MH Academy, India', img: user_4, text: 'An excellent academy with great resources and knowledgeable mentors. I gained valuable skills for my future.' },
    { name: 'Rekha', location: 'MH Academy, India', img: user_5, text: 'The best decision I made was enrolling at MH Academy! Their curriculum is cutting-edge and job-oriented.' },
    { name: 'Vaishnavi', location: 'MH Academy, India', img: user_6, text: 'MH Academy offers high-quality education with practical exposure. The learning experience is fantastic.' },
    { name: 'Divya', location: 'MH Academy, India', img: user_7, text: 'The faculty at MH Academy genuinely cares about students’ growth. I highly recommend it to anyone looking for quality education.' },
    { name: 'Thrisha', location: 'MH Academy, India', img: user_8, text: 'A perfect place to gain knowledge and build a successful career. MH Academy exceeded my expectations!' },
    { name: 'Honnambika', location: 'MH Academy, India', img: user_9, text: 'Innovative teaching methods and great infrastructure make MH Academy stand out. A great experience!' },
    { name: 'Ambika', location: 'MH Academy, India', img: user_10, text: 'If you want to learn from the best, MH Academy is the place to be. The faculty and resources are world-class!' },
    { name: 'Rekha', location: 'MH Academy, India', img: user_11, text: 'A well-rounded institution that offers excellent education with practical applications. Loved my time at MH Academy.' },
    { name: 'Vaishnavi', location: 'MH Academy, India', img: user_12, text: 'The faculty and staff are always there to help. I felt supported throughout my learning journey at MH Academy.' },
    { name: 'Divya', location: 'MH Academy, India', img: user_13, text: 'Their approach to education is unique and effective. I learned so much more than I expected!' },
    { name: 'Ambika', location: 'MH Academy, India', img: user_14, text: 'MH Academy is the best place to gain knowledge and skills. I feel prepared for my future career thanks to their excellent programs.' }
  ];

  // Responsive: Determine how many cards to show
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setItemsPerPage(1);
      else if (window.innerWidth < 1024) setItemsPerPage(2);
      else setItemsPerPage(3);
    };
    
    handleResize(); // Init
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-slide logic
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 4000); // 4 seconds
    return () => clearInterval(interval);
  }, [currentIndex, itemsPerPage]);

  const maxIndex = Math.ceil(reviews.length / itemsPerPage) - 1;

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev >= reviews.length - itemsPerPage ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? reviews.length - itemsPerPage : prev - 1));
  };

  return (
    <section className="testimonials-section">
      {/* Decorative Background Elements */}
      <div className="gradient-orb orb-1"></div>
      <div className="gradient-orb orb-2"></div>

      <div className="testimonials-container">
        <div className="header-content" data-aos="fade-down">
          <h3 className="sub-heading1">Student Success Stories</h3>
          <h2 className="main-heading1">What Our Students Say</h2>
          <div className="heading-line1"></div>
        </div>

        <div className="slider-wrapper" data-aos="fade-up">
          {/* Navigation Buttons */}
          <button className="nav-btn prev-btn" onClick={prevSlide}>
            <ChevronLeft size={28} />
          </button>
          
          <div className="slider-track-container">
            <div 
              className="slider-track" 
              style={{ 
                transform: `translateX(-${currentIndex * (100 / itemsPerPage)}%)` 
              }}
            >
              {reviews.map((review, index) => (
                <div 
                  key={index} 
                  className="review-card-wrapper"
                  style={{ flex: `0 0 ${100 / itemsPerPage}%` }}
                >
                  <div className="review-card">
                    <Quote className="quote-icon-bg" size={60} />
                    
                    <div className="card-header">
                      <div className="img-border">
                        <img src={review.img} alt={review.name} />
                      </div>
                      <div className="user-info">
                        <h3>{review.name}</h3>
                        <span>{review.location}</span>
                        <div className="stars">
                          {[...Array(5)].map((_, i) => (
                            <Star key={i} size={14} fill="#F59E0B" color="#F59E0B" />
                          ))}
                        </div>
                      </div>
                    </div>

                    <p className="review-text">"{review.text}"</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button className="nav-btn next-btn" onClick={nextSlide}>
            <ChevronRight size={28} />
          </button>
        </div>

        {/* Dots Pagination */}
        <div className="pagination-dots">
          {/* We only show a limited number of dots to keep it clean */}
          {reviews.slice(0, reviews.length - itemsPerPage + 1).map((_, idx) => (
             <span
             key={idx}
             className={`dot ${currentIndex === idx ? 'active' : ''}`}
             onClick={() => setCurrentIndex(idx)}
           />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;